import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./PackageDescriptions.css";
export const PackageDescriptions = (props) => {
    const options = props.descriptionStrings;
    const isGreyBar = options[0] === "";
    const listClass = "optionsList ".concat(isGreyBar ? "optionsList_GreyBars" : "optionsList_Default");
    let num = 0;
    const optionsList = options.map((option) => {
        num++;
        const itemClass = isGreyBar ? "optionsListItem_GreyBar" : "optionsListItem";
        const uniqueKey = "uID" + num;
        return (_jsxs("li", Object.assign({ className: itemClass }, { children: [_jsx("span", { children: option }), " ", _jsx("div", {})] }), uniqueKey));
    });
    return (_jsx(_Fragment, { children: _jsx("ul", Object.assign({ className: listClass }, { children: optionsList })) }));
};
